import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DashboardService} from "../../../../services/dashboard/dashboard.service";

@Component({
  selector: 'app-widget-placeholder',
  templateUrl: './widget-placeholder.component.html',
  styleUrls: ['./widget-placeholder.component.css']
})
export class WidgetPlaceholderComponent {

  @Output() configurationCallback = new EventEmitter<unknown>();

  @Input() icon: string = 'app_generic';

  protected dashboardService: DashboardService = inject(DashboardService);

}
